// Import necessary components from MUI
import { Box, BoxProps, styled } from "@mui/material";

const StyledBox = styled(Box)({
  "& p": {
    fontSize: "14px",
    minHeight: "14px",
    display: "block",
    marginTop: "4px",
    marginBottom: "0px",
  },
  "& strong": {
    fontWeight: 600,
  },
  "& i": {},
  "& ul, & ol": {
    paddingLeft: "20px",
    margin: "10px 0",
  },
  "& li": {
    marginBottom: "5px",
  },
});

export const StyledTextEditorContainer = ({
  children,
  ...rest
}: BoxProps & { children: React.ReactNode }) => <StyledBox {...rest}>{children}</StyledBox>;
